module.exports = __webpack_public_path__ + "img/ISO9001.e61a0a1e.png";